import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { calculateDistance, formatDate, getInlineLoader, roundToTwoDecimals } from "../Helpers";
import {
	STR_AVAILABLE_HOTELS,
	STR_AVAILABLE_ROOMS,
	STR_CHANGE_PHONE_NUMBER,
	STR_COMMENT,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_MENU_HOTELS,
	STR_NO_RECORD,
	STR_NOTIFICATIONS,
	STR_OPEN_MAPS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_WRITE_COMMENT,
	STR_ROOMS,
	STR_SUBMIT,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_SUCCESS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REVIEWS,
	STR_VIEW_OR_SEND_REVIEW,
	STR_YOUR_RATING
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCheckCircle, MdContactPage, MdInfoOutline, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdSupportAgent, MdTranslate } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import OneHotelRoom from '../ones/OneHotelRoom';
import ImagesSlider from "../ones/ImagesSlider";
import { CDN_URL, callApi } from "../Helpers";
import { RiPinDistanceLine } from "react-icons/ri";
import { BiNavigation } from "react-icons/bi";
import MobileInterface from "../MobileInterface";
import { FaRegStar, FaStar } from "react-icons/fa";

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [data, setData] = useState(null);
	const [reviews, setReviews] = useState(null);
	const [images, setImages] = useState([]);
	const [rating, setRating] = useState(0);

	const [numberOfStars, setNumberOfStars] = useState(5);
	const [comment, setComment] = useState('');
	const [userReview, setUserReview] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getData(),
			getReviews(),
		]);
		setReady(true);
	}


	async function getData() {
		await callApi('get-hotel-data', { id }).then((response) => {
			if(response.status === 1) {
				setData(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	

	async function getReviews() {
		await callApi('get-hotel-reviews', { hotelId: id }).then((response) => {
			if(response.status === 1) {
				setReviews(response.data)
			} else {
				appContext.tellError('Could not fetch data, check network')
			}
		})
	}

	function calculateRating() {
		let _rating = 5;
		if(reviews && reviews.length > 0) {
			let _totalStars = 0;

			for (const _review of reviews) {
				_totalStars += Number(_review.numberOfStars);
			}

			_rating = Number(_totalStars/reviews.length).toFixed(1);

		} else {
			//leave default rating
		}

		setRating(_rating);
	}

	function getImages() {
		if (data) {
			const _images = [];

			if (data.photo1) {
				_images.push(CDN_URL + data.photo1)
			}

			if (data.photo2) {
				_images.push(CDN_URL + data.photo2)
			}

			if (data.photo3) {
				_images.push(CDN_URL + data.photo3)
			}
			
			if (data.photo4) {
				_images.push(CDN_URL + data.photo4)
			}

			if (data.photo5) {
				_images.push(CDN_URL + data.photo5)
			}

			setImages(_images);
		}
	}

	async function sendReview() {
		if(comment && comment.trim().length > 0) {
			setLoading(true);
			await callApi('send-hotel-review', { hotelId: id, numberOfStars, comment }).then(async (response) => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					await getReviews()
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_PLEASE_WRITE_COMMENT[appContext.language])
		}
		
	}

	function getUserReview() {
		if(reviews && reviews.length > 0) {
			for (const _review of reviews) {
				if(Number(_review.userId) === Number(appContext.currentUserData.id)) {
					setUserReview(_review);
					break;
				}
			}
		}
	}

	useEffect(() => {
		calculateRating();
		getUserReview();
	}, [ reviews ])

	useEffect(() => {
		if(userReview) {
			setComment(userReview.comment);
			setNumberOfStars(userReview.numberOfStars);
		}
	}, [ userReview ])

	useEffect(() => {
		getImages();
	}, [ data ])


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (	
			<div className="container">				
				<div className="row">
					
					<div className="col-md-12">
						<h6
							style={{
								fontSize: "32px"
							}}
							className="mt-4 mb-4 text-secondary font-bold"
						>
							{data.name}
						</h6>


						<div
							className="card"
						>
							<div className="card-body">
								
								<div className="d-flex justify-content-center">
									<FaStar
										size={36}
										className="align-self-center"
										color="#B38B00"
									/>
									<h6
										style={{
											fontSize: "36px",
											color: "#B38B00"
										}}
										className="font-bold align-self-center mNoPadding mNoMargin"
									>
										{rating}
									</h6>
								</div>

								<hr/>

								<div className="mt-3 mb-3">
									<label className="form-label">{STR_YOUR_RATING[appContext.language]}</label>
									<div className="d-flex">
										{
											[1, 2, 3, 4, 5].map((item, i) => {
												if(numberOfStars >= item) {
													return (
														<FaStar
															size={32}
															key={i}
															onClick={() => {
																if(userReview) {
																	return;
																}
																setNumberOfStars(item)
															}}
														/>
													)
												} else {
													return (
														<FaRegStar
															size={32}
															key={i}
															onClick={() => {
																if(userReview) {
																	return;
																}
																setNumberOfStars(item)
															}}
														/>
													)
												}
											})
										}
									</div>
								</div>

								<div className="mt-3 mb-3">
									<label className="form-label">{STR_COMMENT[appContext.language]}</label>
									<textarea
										value={comment}
										onChange={(e) => setComment(e.target.value)}
										className="form-control"
										maxLength={200}
										readOnly={userReview ? true : false}
									/>
								</div>

								<div className="mt-3 mb-3" style={{ display: userReview ? 'none' : 'block' }}>
									<button
										className="btn btn-rounded btn-block btn-padded btn-primary"
										onClick={sendReview}
									>
										{STR_SUBMIT[appContext.language]}
									</button>
								</div>
								
							</div>
							
						</div>
					</div>

					<div className="col-md-12 mt-4">
						<h6
							className="font-bold"
							style={{
								fontSize: "16px",
								textTransform: "uppercase",
							}}
						>
							{STR_USER_REVIEWS[appContext.language]} ({reviews?.length})
						</h6>
					</div>

					{
						(reviews && reviews.length > 0) ?
						reviews.map((item, i) => {
							return (
								<div className="col-12" key={i}>
									<h6
										style={{
											fontSize: "16px"
										}}
									>
										{item.comment}
									</h6>

									<h6
										style={{
											fontSize: "20px"
										}}
										className="font-bold text-muted"
									>
										<FaStar
											size={32}
										/>
										{item.numberOfStars}
									</h6>

									<h6
										style={{
											fontSize: "14px"
										}}
										className="text-end"
									>
										{formatDate(item.dateCreated)}
									</h6>
									<hr/>
								</div>
								
							)
						})
						:
						<h6>{STR_NO_RECORD[appContext.language]}</h6>
					}


				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}